import { FC } from 'react'
import * as yup from 'yup'
import { Formik, FormikValues } from 'formik'
import styles from '../EditCompanyCardMainInformation/EditCompanyCardMainInformation.module.css'
import TitleBlockForEditPages from '../TitleBlockForEditPages/TitleBlockForEditPages'
import CustomInput from '../UI/CustomInput/CustomInput'
import { useAppDispatch, useAppSelector } from '../../redux/types/types'
import { StaffType } from '../../redux/actions/types'
import {
  blockStaff,
  changeCurrentStaffMainInformation,
  getCurrentStaff,
} from '../../redux/actions/staffAction'
import { useNavigate, useParams } from 'react-router-dom'
import PATH from '../../navigation/path'
import s from '../../styles/common/Form.module.css'
import p from '../UI/CustomInput/CustomInput.module.css'
import InputMask from 'react-input-mask'
import { createRoleForRegister, createRoleForTable } from '../../utils/createRoleForRegister'
import usePasswordToggle from '../../hooks/usePasswordToggle'
import BlockSwiper from '../BlockSwiper/BlockSwiper'
import CustomRadio from '../UI/CustomRadio/CustomRadio'
import { useToast } from '../../context/ToastContext'

export type EditStaffMainInformationPropsType = {
  staffData: StaffType
}

const EditStaffMainInformation: FC<EditStaffMainInformationPropsType> = ({ staffData }) => {
  const [PasswordInputType, ToggleIcon] = usePasswordToggle()
  const { token, user } = useAppSelector((state) => state.auth)

  const { currentStaff } = useAppSelector((state) => state.staff)
  const { showSuccess, showError } = useToast()
  const { companyId } = useParams<{ companyId: string }>()

  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const validationSchema = yup.object().shape({
    fullName: yup.string().required('Поле является обязательным'),
    phone: yup
      .string()
      .required('Поле является обязательным')
      .matches(
        /^(\+?\d{0,4})?\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{4}\)?)?$/,
        'Неверный формат',
      ),
    companyName: yup.string().required('Поле является обязательным'),
    role: yup
      .string()
      .required('Поле является обязательным')
      .oneOf(
        staffData.company.role === 'directorPlace'
          ? ([
              'Директор-Зал',
              'Зал',
              'Зал',
              'директор-Зал',
              'Директор-Зал',
              'директор-Зал',
            ] as const)
          : ([
              'Директор-Агент',
              'Агент',
              'агент',
              'директор-агент',
              'директор-Агент',
              'Директор-агент',
            ] as const),
        staffData.company.role === 'directorPlace'
          ? 'Роль может быть только' + ' Директор-Зал или Зал'
          : 'Роль может быть только' + ' Директор-Агент или Агент',
      ),
    email: yup
      .string()
      .email('К сожалению, почта введена неверно, попробуйте еще раз')
      .required('Поле является обязательным'),
    password: yup
      .string()
      .required('Поле является обязательным')
      .min(8, 'Пароль должен' + ' содержать' + ' минимум 8' + ' символов'),
  })

  const onChangeSwipeCheckboxHandler = async (checked: boolean) => {
    await dispatch(
      blockStaff({
        staffId: String(currentStaff.id),
        isBlocked: !checked,
      }),
    )

    // await dispatch(getCurrentStaff({ staffId: workerId, token }))
  }

  const handleSubmitHandler = async (values: FormikValues) => {
    const resultAction = await dispatch(
      changeCurrentStaffMainInformation({
        token,
        staffId: String(staffData.id),
        phone: values.phone,
        fullName: values.fullName,
        email: values.email,
        role: createRoleForRegister(values.role),
        password: values.password,
      }),
    )

    if (changeCurrentStaffMainInformation.rejected.match(resultAction)) {
      showError('Произошла ошибка при изменении данных')
    } else {
      showSuccess('Данные успешно изменены')
      await dispatch(getCurrentStaff({ staffId: String(staffData.id), token }))
    }
  }

  const handleCancel = () => {
    navigate(`${PATH.companyStaffCardPage}${companyId}/${String(staffData.id)}`)
  }

  return (
    <div className={styles.mainInformationBlock}>
      <Formik
        initialValues={{
          fullName: staffData.user.fullName,
          phone: staffData.user.phone,
          companyName: staffData.company.name,
          role: createRoleForTable(staffData.user.role),
          email: staffData.user.email,
          password: staffData.user.password,
        }}
        validateOnBlur
        onSubmit={(values) => handleSubmitHandler(values)}
        validationSchema={validationSchema}
      >
        {(props) => {
          const { values, touched, errors, isValid, handleChange, handleBlur, handleSubmit } = props

          return (
            <>
              <TitleBlockForEditPages
                title='Основная информация'
                disabled={!isValid}
                handleSubmit={handleSubmit}
                handleReset={handleCancel}
              />
              <div className={styles.container}>
                <div className={styles.inputContainer}>
                  <div className={styles.subtitle}>ФИО</div>
                  <div className={styles.rightBlock}>
                    <CustomInput
                      type='text'
                      placeholder=''
                      name='fullName'
                      required
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.fullName}
                      className={
                        errors.fullName && touched.fullName
                          ? `${styles.inputError} ${styles.input}`
                          : styles.input
                      }
                    />
                  </div>
                </div>
                <div className={styles.inputContainer}>
                  <div className={styles.subtitle}>Номер телефона</div>
                  <InputMask
                    mask='+7 (999) 999 9999'
                    type='phone'
                    placeholder=''
                    name='phone'
                    required
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.phone}
                    className={
                      errors.phone && touched.phone
                        ? `${s.inputError} ${p.input} ${styles.input}`
                        : `${p.input} ${styles.input}`
                    }
                  ></InputMask>
                </div>
                <div className={styles.inputContainer}>
                  <div className={styles.subtitle}>Компания</div>
                  <div className={styles.rightBlock}>
                    <div className={styles.companyBlock}>{values.companyName}</div>
                  </div>
                </div>
                <div className={styles.inputContainer}>
                  <div className={styles.subtitle}>Роль</div>
                  <CustomRadio
                    options={
                      staffData.company.role === 'directorPlace'
                        ? ['Директор-зал', 'Зал']
                        : ['Директор-агент', 'Агент']
                    }
                    name='role'
                    onChange={handleChange}
                    value={values.role}
                  />
                  {touched.role && errors.role && (
                    <p style={{ textAlign: 'start' }} className={styles.errorValidation}>
                      {errors.role}
                    </p>
                  )}
                </div>
                <div className={styles.inputContainer}>
                  <div className={styles.subtitle}>Электронная почта/Логин</div>
                  <CustomInput
                    type='text'
                    placeholder=''
                    name='email'
                    required
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.email}
                    className={
                      errors.email && touched.email
                        ? `${styles.inputError} ${styles.input}`
                        : styles.input
                    }
                  />
                </div>
                <div className={styles.inputContainer}>
                  <div className={styles.subtitle}>Пароль</div>
                  <div className={styles.inputContainerWithError}>
                    <CustomInput
                      type={PasswordInputType}
                      placeholder=''
                      name='password'
                      required
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.password}
                      className={
                        errors.password && touched.password
                          ? `${styles.inputError} ${styles.input}`
                          : styles.input
                      }
                    />
                    <div className={styles.eyeIcon}>{ToggleIcon}</div>
                    {touched.password && errors.password && (
                      <p style={{ textAlign: 'start' }} className={s.errorValidation}>
                        {errors.password}
                      </p>
                    )}
                  </div>
                </div>
                {user.employee.id != currentStaff.id && (
                  <div className={styles.inputContainer}>
                    <div className={styles.subtitle}>Заблокировать</div>
                    {user.employee.id != currentStaff.id && (
                      <BlockSwiper
                        isBlocked={currentStaff.user.isBlocked}
                        onChangeHandler={onChangeSwipeCheckboxHandler}
                      />
                    )}
                  </div>
                )}
              </div>
            </>
          )
        }}
      </Formik>
    </div>
  )
}

export default EditStaffMainInformation
